import React, { useContext, useEffect, useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FiCheck, FiX } from "react-icons/fi";
import siteConfig from "../config/siteConfig";
import { CartContext } from "./CartContext";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const isSuccess = searchParams.get("state") === "success";
  const order = useMemo(() => {
    try { return JSON.parse(window.sessionStorage.getItem("rumnwillow-pending-order-v1") || "null"); }
    catch { return null; }
  }, []);

  useEffect(() => {
    if (isSuccess) clearCart();
  }, [clearCart, isSuccess]);

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className={`payment-success ${isSuccess ? "is-success" : "is-cancel"}`}>
      <section className="payment-success__card" aria-labelledby="payment-title">
        <div className="payment-success__mark" aria-hidden="true">
          {isSuccess ? <FiCheck /> : <FiX />}
        </div>
        <p className="payment-success__eyebrow">{isSuccess ? "Payment successful" : "Payment cancelled"}</p>
        <h1 id="payment-title">{isSuccess ? "Thank you for your order" : "Your order was not completed"}</h1>
        <p className="payment-success__copy">
          {isSuccess
            ? "Your payment was completed and your order is now being prepared. We will send order updates to your checkout email."
            : "No completed payment was recorded. Your items are still in your bag, so you can review the order and try again when you are ready."}
        </p>
        {order && (
          <dl className="payment-success__details">
            {order.orderNo && <div><dt>Order</dt><dd>{order.orderNo}</dd></div>}
            {order.email && <div><dt>Contact</dt><dd>{order.email}</dd></div>}
            {order.amount && <div><dt>Total</dt><dd>{order.currency} {order.amount}</dd></div>}
          </dl>
        )}
        <div className="payment-success__notice">
          <span aria-hidden="true">✦</span>
          <p>
            {isSuccess
              ? `Please allow ${siteConfig.policies?.dispatchTime || "1–2 business days"} for order preparation.`
              : "If an amount appears as pending, your payment provider will update it according to its normal processing time."}
          </p>
        </div>
        <div className="payment-success__actions">
          <Link to={isSuccess ? "/shop" : "/checkout"} onClick={toTop}>{isSuccess ? "Continue shopping" : "Return to checkout"}</Link>
          <Link to="/contact" onClick={toTop}>Contact customer care</Link>
        </div>
      </section>
    </main>
  );
};

export default PaySuccess;
